<script setup lang="ts">
import type { CookieApp } from '../types/cookies';
import { Dropdown } from 'floating-vue';
import { useLegalPortalURL } from '../composables/portalUrls';
import { useBottomDialog } from '../composables/useBottomDialog';
import DropdownItem from './DropdownItem.vue';
import Icon from './Icon.vue';

// type HelpPortalURL = Parameters<typeof useHelpPortalURL>[0];
type LegalPortalURL = Parameters<typeof useLegalPortalURL>[0];

const props = defineProps<{
	app?: CookieApp;
	isLight?: boolean;
	isAbsolute?: boolean;
	hasHelp?: boolean;
}>();

const imprintDialog = useBottomDialog({
	key: 'imprint',
	listen: false,
});
const cookieSettingsDialog = useBottomDialog<CookieApp>({
	key: 'cookie-settings',
	listen: false,
});
</script>

<template>
	<div
		class="copyright"
		:class="[{
			'copyright--is-light': props.isLight,
			'copyright--is-absolute': props.isAbsolute,
		}]"
	>
		<span class="copyright__text">&copy; Hahnemühle {{ new Date().getFullYear() }}</span>
		<ClientOnly v-if="props.hasHelp">
			<span class="copyright__dot"></span>
			<Dropdown position="top">
				<button type="button" class="copyright__button">
					<Icon name="help" />
					<span>Help</span>
				</button>

				<template #popper>
					<!-- <DropdownItem
						label="Contact support"
						icon="headset"
						:to="useHelpPortalURL() as HelpPortalURL"
						target="_blank"
					/>
					<HmDivider class="c:basic-200" /> -->
					<DropdownItem
						label="Privacy Policy"
						icon="file-shield"
						size="sm"
						:to="useLegalPortalURL('privacy-policy') as LegalPortalURL"
						target="_blank"
					/>
					<DropdownItem
						label="Terms of Use"
						icon="files"
						size="sm"
						:to="useLegalPortalURL('general-terms-and-conditions') as LegalPortalURL"
						target="_blank"
					/>
					<DropdownItem
						label="Imprint"
						icon="brand-hahnemuehle-logo"
						size="sm"
						v-close-popper
						@click="imprintDialog.setDialogVisibility(true)"
					/>
					<DropdownItem
						label="Cookie settings"
						icon="cookie"
						size="sm"
						v-if="props.app"
						v-close-popper
						@click="cookieSettingsDialog.setDialogVisibility(true, props.app)"
					/>
				</template>
			</Dropdown>
		</ClientOnly>
	</div>
</template>
